<template>
  <div class="mind-map-container">
    <div ref="mindMapContainer" class="mind-map"></div>
  </div>
</template>

<script>
import { ref, onMounted, onBeforeUnmount, watch } from 'vue'
import MindElixir from 'mind-elixir'

export default {
  name: 'MindMap',
  props: {
    modelValue: {
      type: Object,
      required: true
    }
  },
  emits: ['update:modelValue'],
  setup(props, { emit }) {
    const mindMapContainer = ref(null)
    let mind = null

    const initMindMap = () => {
      mind = new MindElixir({
        el: mindMapContainer.value,
        direction: MindElixir.LEFT,
        draggable: true,
        contextMenu: true,
        toolBar: true,
        nodeMenu: true,
        keypress: true

      })
      mind.init(props.modelValue)
      mind.bus.addListener('operation', () => {
        emit('update:modelValue', mind.getData())
      })
    }

    onMounted(() => {
      initMindMap()
    })

    watch(() => props.modelValue, (newVal) => {
      if (mind && JSON.stringify(mind.getData()) !== JSON.stringify(newVal)) {
        mind.refresh(newVal)
      }
    })

    onBeforeUnmount(() => {
      // mind-elixir v3.x 没有 destroy 方法，无需手动销毁
    })

    return {
      mindMapContainer
    }
  }
}
</script>


<style scoped>
.mind-map-container {
  width: 100%;
  height: 100%;
  min-height: 500px;
  background: #fff;
}

.mind-map {
  width: 100%;
  height: 100%;
  min-height: 600px;
}
</style> 